<div id="blocker" class="blocker" *ngIf="showIf">
	<mat-spinner color="primary" [diameter]="diameter"></mat-spinner>
</div>
<ng-content class="content"></ng-content>
